import { AxiosResponse } from 'axios';
import { csrfToken, instance } from '../db';
import { FavoriteGetType } from '../../validation/favorite/favoriteType';

// お気に入り取得API
export const getFavorites = async (
  limit: number,
  offset: number,
  order: number,
  method: number
): Promise<FavoriteGetType> => {
  const response = await instance.get(
    `/favorite?limit=${limit}&offset=${offset}&order=${order}&method=${method}`,
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response.data;
};

// お気に入り削除API
export const deleteFavorite = async (
  productId: number
): Promise<AxiosResponse> => {
  const response = await instance.delete(`/favorite`, {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    },
    data: { product_id: productId }
  });
  return response;
};

// お気に入り追加API
export const addFavorite = async (
  productId: number
): Promise<AxiosResponse> => {
  const response = await instance.post(
    `/favorite`,
    {
      product_id: productId
    },
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response;
};
